<template>
  <div v-if="!isReadonly" class="linked-data-actions">
    <UIButtonSync
      v-if="hasConnectors"
      :leading="ArrowPathIcon"
      :loading="syncing"
      :disabled="isDisabled"
      label="Sync"
      variant="secondary"
      fill="light"
      size="sm"
      hide-label-to-sm
      @click="handleSyncAccounts"
    />
    <UIButton
      label="Connect"
      :leading="PlusIcon"
      size="sm"
      hide-label-to-sm
      @click="handleAddAccount"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, markRaw } from 'vue'

import { ReadonlyMode } from '@types'

import { READONLY_MODE } from '@/const/common'

import { useLinkedDataConnector } from '@/hooks/linkedDataConnector'

import { useLinkedDataConnectorsStore } from '@/store/linkedData/connectors'
import { useModalsStore } from '@/store/modals'

import AddAccount from '@/views/LinkedData/Connectors/components/AddAccount.vue'
import { ArrowPathIcon, PlusIcon } from '@heroicons/vue/24/outline'
import { UIButton, UIButtonSync } from '@ui/buttons'

const linkedDataConnectorsStore = useLinkedDataConnectorsStore()
const modalsStore = useModalsStore()

const { loading, syncing, sync: handleSyncAccounts } = useLinkedDataConnector()

const isReadonly = inject<ReadonlyMode>(READONLY_MODE)

const isDisabled = computed(() => syncing.value || loading.value)

const hasConnectors = computed(
  () => !!linkedDataConnectorsStore.getList?.length,
)

const handleAddAccount = () => {
  const modalInstance = modalsStore.init('add-account', markRaw(AddAccount))
  modalInstance?.open(modalsStore.getZIndex())
}
</script>

<style>
.linked-data-actions {
  @apply flex items-center;
  @apply gap-2;
}
</style>
